// export const env = 'development';
// export const domain = 'http://192.168.0.29:8000/api/v1';

// export const env = process.env.REACT_APP_NODE_ENV;
// export const domain = process.env.REACT_APP_URL;

export const env = 'production';
export const domain = 'https://vip-api.trakngo.com.au/api/v1';
